export default {"src":"/_next/static/media/add-plus-icon.763a994a.svg","height":24,"width":24};